module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lJP4R"))).then(() => parcelRequire('hEqeo'));